export const CANCELLATION_POLICY_SECTIONS = [
  {
    icon: '🧳',
    title: 'Individual Bookings (FIT)',
    points: [
      'More than 7 days prior to check-in: No cancellation charges. Any advance received shall be refunded after deduction of applicable bank/payment gateway charges.',
      '3 to 7 days prior to check-in: 50% of the booking value shall be charged.',
      "Less than 72 hours before check-in, or No-Show: 100% of the first night's room charges shall be forfeited.",
    ],
  },
  {
    icon: '👨‍👩‍👧‍👦',
    title: 'Group Bookings (10 Rooms or More)',
    points: [
      'More than 30 days prior to arrival: No cancellation charges.',
      '15 to 30 days prior to arrival: 25% of the total booking value shall be charged.',
      '7 to 14 days prior to arrival: 50% of the total booking value shall be charged.',
      'Less than 7 days prior to arrival, or No-Show: 100% of the advance amount shall be forfeited.',
    ],
  },
  {
    icon: '🎉',
    title: 'Festival & Peak Season Bookings',
    points: [
      'Bookings made during festivals, long weekends, New Year, Ram Navami, Deepotsav, Kartik Purnima, and other notified peak periods may be non-cancellable, non-refundable, and non-amendable, unless specifically mentioned otherwise in the booking confirmation.',
    ],
  },
  {
    icon: '✏️',
    title: 'Amendments',
    points: [
      'Any change in arrival date, departure date, number of rooms, or guest details shall be subject to room availability and prevailing tariff.',
      'Amendments requested within 72 hours of arrival may be treated as a cancellation and fresh booking.',
    ],
  },
  {
    icon: '🚪',
    title: 'Early Departure',
    points: [
      'In case a guest checks out before the confirmed departure date, the hotel reserves the right to charge for the unused room nights as per the confirmed reservation.',
    ],
  },
  {
    icon: '🚫',
    title: 'No-Show',
    points: [
      'Failure to arrive on the scheduled check-in date without prior written intimation shall be treated as a No-Show, and the applicable cancellation charges shall apply.',
      'The hotel reserves the right to release the room for further sale.',
    ],
  },
  {
    icon: '💰',
    title: 'Refunds',
    points: [
      'Eligible refunds shall be processed within 7–10 working days from the date of cancellation approval.',
      'Refunds shall be made through the original mode of payment only.',
      'Bank charges, payment gateway charges, taxes, or any third-party transaction charges, wherever applicable, may be deducted from the refundable amount.',
    ],
  },
  {
    icon: '⚠️',
    title: 'Force Majeure',
    points: [
      'The hotel shall not be liable for any cancellation, delay, or failure to provide accommodation due to events beyond its reasonable control, including natural disasters, government restrictions, strikes, pandemics, or other force majeure events.',
      'In such cases, refunds or rescheduling shall be considered at the sole discretion of the management.',
    ],
  },
  {
    icon: '👔',
    title: "Management's Decision",
    points: [
      'The Management reserves the right to modify this policy without prior notice.',
      'Any exception to the above terms shall be valid only if confirmed in writing by the hotel management.',
    ],
  },
];
